import React, { useState } from 'react';
import OrderList from './components/OrderList';
import OrderEntryForm from './components/OrderEntryForm';
import FabricationWorkOrder from './components/FabricationWorkOrder';
import ScrapBank from './components/ScrapBank';
import Inventory from './components/Inventory';

function App() {
  const [currentView, setCurrentView] = useState('list');
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleSelectOrder = (order) => {
    setSelectedOrder(order);
    setCurrentView('details');
  };

  const handleCreateNew = () => {
    setSelectedOrder(null);
    setCurrentView('form');
  };

  const handleSaveOrder = (order) => {
    setSelectedOrder(order);
    setCurrentView('details');
  };

  const handleUpdateOrder = (updatedOrder) => {
    setSelectedOrder(updatedOrder);
  };

  return (
    <div className="min-h-screen bg-deep-navy print:bg-white print:min-h-0">
      {/* Header - hidden in print */}
      <header className="header no-print">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center py-4 sm:py-5">
            {/* Logo & Title */}
            <div className="text-center sm:text-left mb-4 sm:mb-0">
              <p className="header-logo mb-1">Bliss Luxury Bunk Co.</p>
              <h1 className="header-title">Cut List Generator</h1>
            </div>
            
            {/* Navigation */}
            <nav className="flex flex-wrap items-center justify-center gap-2">
              <button
                onClick={() => setCurrentView('list')}
                className={`nav-tab ${
                  currentView === 'list' ? 'nav-tab-active' : 'nav-tab-inactive'
                }`}
              >
                Orders
              </button>
              <button
                onClick={() => setCurrentView('inventory')}
                className={`nav-tab ${
                  currentView === 'inventory' ? 'nav-tab-active' : 'nav-tab-inactive'
                }`}
              >
                📦 Inventory
              </button>
              <button
                onClick={() => setCurrentView('scrapbank')}
                className={`nav-tab ${
                  currentView === 'scrapbank' ? 'nav-tab-active' : 'nav-tab-inactive'
                }`}
              >
                ♻️ Scrap Bank
              </button>
              {selectedOrder && (
                <>
                  <button
                    onClick={() => setCurrentView('workorder')}
                    className={`nav-tab ${
                      currentView === 'workorder' ? 'nav-tab-active' : 'nav-tab-inactive'
                    }`}
                  >
                    Work Order
                  </button>
                  <button
                    onClick={() => setCurrentView('details')}
                    className={`nav-tab ${
                      currentView === 'details' ? 'nav-tab-active' : 'nav-tab-inactive'
                    }`}
                  >
                    Details
                  </button>
                  <button
                    onClick={() => {
                      setCurrentView('form');
                    }}
                    className="nav-tab nav-tab-inactive"
                  >
                    Edit
                  </button>
                </>
              )}
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-8 px-4 sm:px-6 lg:px-8 print:py-0 print:px-0">
        <div className="max-w-7xl mx-auto print:max-w-none">
          {currentView === 'list' && (
            <OrderList
              onSelectOrder={handleSelectOrder}
              onCreateNew={handleCreateNew}
            />
          )}
          
          {currentView === 'inventory' && (
            <Inventory />
          )}
          
          {currentView === 'scrapbank' && (
            <ScrapBank />
          )}
          
          {currentView === 'form' && (
            <OrderEntryForm
              initialOrder={selectedOrder}
              onSave={handleSaveOrder}
            />
          )}
          
          {currentView === 'workorder' && (
            <FabricationWorkOrder order={selectedOrder} onUpdate={handleUpdateOrder} />
          )}
          
          {currentView === 'details' && selectedOrder && (
            <div className="max-w-4xl mx-auto">
              <div className="card p-8">
                <h2 className="text-2xl font-light text-warm-gold mb-6">Order Details</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div>
                    <span className="info-label">Order #</span>
                    <span className="info-value">{selectedOrder.orderNumber}</span>
                  </div>
                  <div>
                    <span className="info-label">Customer</span>
                    <span className="info-value">{selectedOrder.customerName || 'N/A'}</span>
                  </div>
                  <div>
                    <span className="info-label">Configuration</span>
                    <span className="info-value">{selectedOrder.bedConfig}</span>
                  </div>
                  <div>
                    <span className="info-label">Wood Type</span>
                    <span className="info-value">{selectedOrder.woodType}</span>
                  </div>
                  <div>
                    <span className="info-label">Finish</span>
                    <span className="info-value">{selectedOrder.finish}</span>
                  </div>
                  <div>
                    <span className="info-label">Due Date</span>
                    <span className="info-value">{selectedOrder.dueDate || 'N/A'}</span>
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={() => setCurrentView('workorder')}
                    className="btn-gold px-6 py-3 text-sm"
                  >
                    View Work Order
                  </button>
                  <button
                    onClick={() => setCurrentView('form')}
                    className="btn-gold-outline px-6 py-3 text-sm"
                  >
                    Edit Order
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
